import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-grid">
        <div>
          <h1 className="heading-display mb-6">
            Bienestar corporativo con <em>una mirada distinta</em>
          </h1>
          <p className="body-large mb-8 max-w-xl">
            Programas de bienestar que las personas recuerdan, aplican y
            agradecen — combinando nutrición, fitoterapia y educación práctica
            para mejorar la salud y el compromiso de tus equipos.
          </p>
          <button onClick={scrollToContact} className="btn-primary">
            Conversemos sobre el bienestar de tu equipo
            <ArrowRight className="w-5 h-5 ml-2" />
          </button>
        </div>

        <div className="hero-image-frame">
          <img
            src="/hero-charla.jpg"
            alt="Colaboradores asistiendo a una charla de bienestar en la oficina"
            width="1920"
            height="1080"
            loading="eager"
            fetchpriority="high"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
